import * as React from 'react';
import { ButtonRadioGroupField } from '@cian/components';
import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../../common/state';
import { ERentTime } from '../../../../json_query';
import { changeRentTime } from '../../../state/advanced/rent_time';
import { InlineParam, Row } from '../markup';

export interface IRentTimeProps {
  rentTime: ERentTime;
  onRentTimeChanged(value: string | undefined): void;
}

export const rentTime: React.StatelessComponent<IRentTimeProps> = props => (
  <Row title="Срок аренды">
    <InlineParam>
      <ButtonRadioGroupField
        uncheckable
        value={props.rentTime}
        onValueChange={value => props.onRentTimeChanged(value !== undefined ? value : ERentTime.NotDaily)}
        values={[
          { value: ERentTime.FromYear, label: 'От года' },
          { value: ERentTime.FewMonths, label: 'Несколько месяцев' },
        ]}
      />
    </InlineParam>
  </Row>
);

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    rentTime: (state.filters.jsonQuery.for_day && state.filters.jsonQuery.for_day.value) || ERentTime.NotDaily,
  }),
  (dispatch: Dispatch) => ({
    onRentTimeChanged: (value: ERentTime) => {
      dispatch(changeRentTime(value));
    },
  }),
)(rentTime);
